/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconOngoing/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconOngoing({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconOngoing",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#323232",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconOngoing.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1Tpj0E': alignSelf,'--mt-2-Z1Tpj0E': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1Tpj0E': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1Tpj0E': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1Tpj0E': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1Tpj0E': opacity,'--w-10-Z1Tpj0E': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1Tpj0E': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1Tpj0E': fill,'--a-7-Z1Tpj0E': isAnimated ? animation : "none",'--sd-8-Z1Tpj0E': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1Tpj0E': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconOngoing.SvgPath"
  data-view-path={viewPath}
 d="M18.6 19.5H21v2h-6v-6h2v2.73c1.83-1.47 3-3.71 3-6.23 0-4.07-3.06-7.44-7-7.93V2.05c5.05.5 9 4.76 9 9.95 0 2.99-1.32 5.67-3.4 7.5zM4 12c0-2.52 1.17-4.77 3-6.23V8.5h2v-6H3v2h2.4A9.966 9.966 0 002 12c0 5.19 3.95 9.45 9 9.95v-2.02c-3.94-.49-7-3.86-7-7.93z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}